import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import config from '@/config'

// 按需导入图标，减少打包体积
// 在需要的组件中单独导入图标

const app = createApp(App)

// 全局配置
app.config.globalProperties.$config = config

app.use(createPinia())
app.use(router)
app.use(ElementPlus, {
  locale: zhCn,
  size: config.form.size
})

// 全局错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('全局错误:', err, info)
}

app.mount('#app')
